import { render } from "./v-main-page.vue?vue&type=template&id=1063323d"
import script from "./v-main-page.vue?vue&type=script&lang=js"
export * from "./v-main-page.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__